import {
  DataTable,
  IconButton,
  Switch,
  Text,
  Tooltip,
} from '@dixa/lib-shared-habla';

import { ScoreIcon } from 'fable/ScoreIcon';

import { DixaMessengerCSAT } from '../../types';

interface Props {
  languages: DixaMessengerCSAT.Language[];
  onLanguageStatusChange: LanguageStatusChangeHandler;
  onEdit: (language: DixaMessengerCSAT.Language) => void;
  disabled?: boolean;
  notAllowedToBeDisabledLanguages?: string[];
}

type LanguageStatusChangeHandler = (
  change: DixaMessengerCSAT.LanguageCustomizationStatusChange,
) => void;

export const LanguageCustomizationList = ({
  languages,
  disabled,
  notAllowedToBeDisabledLanguages,
  onEdit,
  onLanguageStatusChange,
}: Props): JSX.Element => {
  return (
    <DataTable
      data={languages}
      columns={[
        {
          label: 'Language',
          selector: (language) => (
            <Text.Paragraph color={language.isSetup ? 'primary' : 'tertiary'}>
              {language.name}
            </Text.Paragraph>
          ),
        },
        {
          label: 'Rating style',
          selector: (language) =>
            language.ratingStyle ? (
              <ScoreIcon
                key={`${language.code}-rating-style`}
                score={5}
                style={language.ratingStyle}
                size={25}
              />
            ) : null,
        },

        {
          label: 'Enabled',
          selector: (language) => {
            if (language.isSetup) {
              return (
                <Switch
                  name={language.code}
                  value={language.code}
                  checked={language.enabled}
                  disabled={
                    disabled ||
                    (language.enabled &&
                      notAllowedToBeDisabledLanguages?.includes(language.code))
                  }
                  onChange={() =>
                    onLanguageStatusChange({
                      language,
                      newStatus: !language.enabled,
                    })
                  }
                />
              );
            }
          },
          style: {
            width: 0,
          },
        },

        {
          label: '',
          selector: (language) => {
            return (
              <Tooltip content={language.isSetup ? 'Edit' : 'Setup'}>
                <IconButton
                  icon={language.isSetup ? 'pen' : 'cog'}
                  variant="tertiary"
                  onClick={() => onEdit(language)}
                  disabled={disabled}
                />
              </Tooltip>
            );
          },
          style: {
            width: 0,
          },
        },
      ]}
    />
  );
};
